import React from 'react';

export default () => {
  return (
    <div style={{ color: 'teal' }}>
      <h1>Hello This is me</h1>
    </div>
  );
};
